export default {
  darkThemeEnabled: state => state.general.darkTheme
}
